module.exports = __webpack_public_path__ + "CreativeDirection12.png?f6cbce3599641af5ee9270261d08a207";


//////////////////
// WEBPACK FOOTER
// ./src/assets/CreativeDirection12.png
// module id = 23
// module chunks = 0